<template>
  <header class="header" :class="[this.scrollDown ? 'l-topbar-compact' : '']">
    <!-- <header class="header " > -->
    <div class="l-title">
      <h1 class="header__title">Energy Futures Dashboard (select for 2050)</h1>
      <div class="header__subtitle">
        A product of the <a href="https://energy.utexas.edu/policy/eiof" target="_blank" class="studylink">Energy Infrastructure of the Future Study</a>
        <div class="header__subtitile">
          Version 1.0.1
        </div>
      </div>
    </div>

    <div class="l-logo logo">
      <a href="https://energy.utexas.edu/policy/eiof" target="_blank">
        <img src="@/assets/images/energyInstitute.svg" alt="The Energy Institute" />
      </a>
    </div>

    <img src="@/assets/images/compact.svg" class="btn-compact" id="compact" alt="Minimize" />
  </header>
</template>

<script>
import JQuery from 'jquery';

let $ = JQuery;

export default {
  name: 'Topbar',
  data() {
    return {
      scrollDown: false
    };
  },
  methods: {
    handleCompactClick(e) {
      $('.header').toggleClass('l-topbar-compact');
      $(e.target).toggleClass('up');
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    $('#compact').on('click', evt => {
      this.handleCompactClick(evt);
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  height: 100px;
  width: 100%;
  overflow: hidden;
  padding: 0 0.75rem;

  color: white;
  background-color: #bf5700;

  .header__title {
    padding: 0;
    margin: 0;
  }

  .header__subtitle {
    margin-left: 2px;
    font-size: 1rem;
  }
}

.l-title {
  float: left;
  padding: 1rem;
}

.l-logo {
  float: right;
  padding: 1.5rem 1rem 1rem 1rem;
}

.logo {
  width: 320px;
}

/*Compact layout*/

.btn-compact {
  position: absolute;
  bottom: -4px;
  right: 0.5rem;
  width: 30px;
  cursor: pointer;
  background: url('../assets/images/compact-up.svg');

  &.up {
    background: url('../assets/images/compact-down.svg');
  }
}

.l-topbar-compact.header {
  height: 35px;
  padding: 0 0.75rem;
}

.l-topbar-compact .header__title {
  font-size: 0.9rem;
}

.l-topbar-compact .l-title {
  padding: 2px;
}

.l-topbar-compact .header__subtitle {
  font-size: 0.6rem;
  margin-left: 0;
}

.l-topbar-compact .l-logo {
  float: right;
  padding: 4px 0.5rem 0 0;
}

.l-topbar-compact .logo {
  width: 150px;
}

.studylink {
  color: white;
  text-decoration: underline;
}
</style>
